import React from "react";

/**
 * Google sign-in button using the Emergent-managed OAuth flow.
 *
 * `intent` = "customer" (default) → callback path /site/auth-callback (customer_token cookie)
 * `intent` = "staff"              → callback path /auth-callback       (access_token cookie)
 *
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
 */
export default function GoogleSignInButton({
  intent = "customer",
  label = "Continue with Google",
  className = "",
}) {
  const handleClick = () => {
    const callbackPath = intent === "staff" ? "/auth-callback" : "/site/auth-callback";
    const redirectUrl = window.location.origin + callbackPath;
    window.location.href =
      `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      data-testid={`google-signin-${intent}`}
      className={
        "w-full flex items-center justify-center gap-2 border border-gray-300 " +
        "bg-white hover:bg-gray-50 text-gray-800 font-medium text-sm " +
        "rounded-md py-2.5 transition-colors " + className
      }
    >
      <svg width="16" height="16" viewBox="0 0 48 48" aria-hidden="true">
        <path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3c-1.6 4.7-6.1 8-11.3 8-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.9 1.2 8 3.1l5.7-5.7C34.6 6.1 29.6 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.3-.1-2.4-.4-3.5z"/>
        <path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.7 15.5 19 12 24 12c3.1 0 5.9 1.2 8 3.1l5.7-5.7C34.6 6.1 29.6 4 24 4 16.3 4 9.7 8.4 6.3 14.7z"/>
        <path fill="#4CAF50" d="M24 44c5.4 0 10.3-2 13.9-5.3l-6.4-5.4c-2 1.4-4.6 2.3-7.5 2.3-5.2 0-9.6-3.3-11.3-7.9l-6.5 5C9.6 39.5 16.2 44 24 44z"/>
        <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.3-2.2 4.2-4 5.7l6.4 5.4C41.2 36.1 44 30.5 44 24c0-1.3-.1-2.4-.4-3.5z"/>
      </svg>
      {label}
    </button>
  );
}
